/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('allow_end_users_to_access_custom_templates');
	},
};
